/**
 * Shared constants for DIY feature
 */

export const CATEGORY_LABELS: Record<string, string> = {
  drywall: 'Drywall',
  electrical: 'Electrical',
  plumbing: 'Plumbing',
  painting: 'Painting',
  flooring: 'Flooring',
  carpentry: 'Carpentry',
  roofing: 'Roofing',
  hvac: 'HVAC',
  landscaping: 'Landscaping',
  appliances: 'Appliances',
  bathroom: 'Bathroom',
}

export function getCategoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? category
}
